'use client';

import { useContext } from 'react';
import { usePathname } from 'next/navigation';
import { MobileNavbar } from './mobile-navbar';
import { DesktopNavbar } from './desktop-navbar';
import type { GlobalNavigationCategory } from './types';
import { NavbarModeContext } from './navbar-mode-context';

const GlobalNavigation = (props: GlobalNavigationProps) => {
	// When context is available, we use the mode from the context. This allows us to change
	// the mode if we encounter an error that bubbles up to the top route level error boundary.
	const { mode = props.mode ?? 'inline' } = useContext(NavbarModeContext) ?? {};
	// Since the navbar is rendered in a layout, it stays mounted between routes.
	// Key the navbars by pathname so that they remount on route changes to reset the state.
	const pathname = usePathname();

	return (
		<>
			<MobileNavbar {...props} key={`mobile-navbar-${pathname}`} mode={mode} />
			<DesktopNavbar
				{...props}
				key={`desktop-navbar-${pathname}`}
				mode={mode}
			/>
		</>
	);
};

export default GlobalNavigation;

export interface GlobalNavigationProps {
	categories: GlobalNavigationCategory[];
	navigationMakeADonationCode?: number;
	navigationMembershipCode?: number;
	navigationBuyTicketsCode?: number;
	mode?: 'overlay' | 'inline';
}
